/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Model_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose the model that powers Uno. Usage is billed like regular chat usage at the selected model's rates." |
*
* @param {Uno_Settings_Model_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_description = /** @type {((inputs?: Uno_Settings_Model_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das Modell, das Uno antreibt. Die Nutzung wird wie normale Chat-Nutzung zu den Preisen des ausgewählten Modells abgerechnet.")
	return /** @type {LocalizedString} */ ("Choose the model that powers Uno. Usage is billed like regular chat usage at the selected model's rates.")
});